import React from 'react';
import cn from 'classnames';

import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import { Plus, Minus } from '@lt/components/icons-react/rebrand';

import type { Props } from './types';
import styles from './zoomControlButtons.module.css';

const YMapControlButton = loadReactComponent(
  'YMapControlButton',
  loadModulePromise,
);

const ZoomControlButtons = ({ isMobile, readonlyZoom, setZoom }: Props) => {
  const increaseZoom = () => {
    setZoom(readonlyZoom.current + 1);
  };

  const decreaseZoom = () => {
    setZoom(readonlyZoom.current - 1);
  };

  return (
    <YMapControlButton>
      <div
        className={cn(styles.zoomControl, {
          [styles.mobileZoomControl]: isMobile,
        })}
      >
        <button
          type="button"
          className={styles.zoomButton}
          onClick={decreaseZoom}
        >
          <Minus className={styles.zoomButtonIcon} />
        </button>
        <button
          type="button"
          className={styles.zoomButton}
          onClick={increaseZoom}
        >
          <Plus className={styles.zoomButtonIcon} />
        </button>
      </div>
    </YMapControlButton>
  );
};

export default ZoomControlButtons;
